//import update from 'immutability-helper';
import { 
	PROCESS_ANNOTATION,
	// FETCH_GRAPH_DOCUMENT,
	// SET_TRAVERSAL_OBJECTIVES,
	// APPLY_TRAVERSAL_OBJECTIVE,
	// ensureArray
} from 'meld-clients-core/lib/actions/index'

const INIT_STATE = {
//    graph: {  
//        annoGraph: {}, 
//        targetsById: {}, 
//        targetsByType: {}
	//    },
	targets: {},
	bodies: {}
}

export default function (state = INIT_STATE, action){
	switch(action.type){
		case PROCESS_ANNOTATION:
			console.log("yay");
/*			console.log(state);/*
			for(var i=0; i<state.outcomes.length; i++){
			}*/
			return state;
		default:
			return state;
	}
	
}
